import { PageHeadButtonProps, PageHeadProps } from '../types';

import { isButtonPropsTuple } from './isButtonPropsTuple';

/**
 * Приводит `buttonProps` к массиву, чтобы одну и две кнопки можно было отрисовать одним `map`.
 * @kind helper
 * @param buttonProps - пропсы кнопок PageHead: `undefined`, одиночный объект или tuple
 * @returns массив пропсов кнопок: `[]` для `undefined`, `[obj]` для одиночного объекта, tuple как есть
 */
export const normalizeButtons = (buttonProps: PageHeadProps['buttonProps']): readonly PageHeadButtonProps[] => {
    if (!buttonProps) {
        return [];
    }

    if (isButtonPropsTuple(buttonProps)) {
        return buttonProps;
    }

    return [buttonProps];
};
